var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"hmczimun"}},[_c('router-view'),_c('modal',{attrs:{"name":"pageLoader","adaptive":true,"height":"auto","styles":"background-color:initial;overflow:initial;box-shadow:initial;"}},[_c('PageLoader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }